export default "__VITE_ASSET__C6W4wp6s__"